<template>
  <div class="antialiased">
    <Sidebar />

    <div class="page">
      <Header hint="Cari" :enabled="false" />

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Laporan Retur Segmen</h2>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto">
                    <button
                      class="btn btn-white"
                      v-html="ic('filter')"
                      @click="data_filter.form = true"
                    ></button>
                    <div class="btn-group ml-3">
                      <button
                        class="btn btn-outline-primary"
                        :disabled="data_laporan.data.length <= 0"
                        v-html="ic('download') + ' Export PDF'"
                        @click="exportPDF()"
                      ></button>
                      <button
                        class="btn btn-outline-primary"
                        :disabled="isDownloadExcel || data_laporan.data.length <= 0"
                        v-html="isDownloadExcel ? spin() : ic('download') + ' Export Excel'"
                        @click="exportExcel"
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Skeleton
            type="table"
            :length="10"
            class="mt-3 bg-white"
            v-if="loading"
          />

          <div
            class="alert alert-info"
            v-if="!loading && !data_filter.isFilter"
          >
            <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat data Retur
            Segmen<!--  <br>{{data_laporan}} -->
          </div>
          <Nodata
            v-if="
              !loading && data_laporan.data.length == 0 && data_filter.isFilter
            "
          />

          <div
            class="text-center"
            v-if="!loading && data_laporan.data.length > 0"
          >
            <div class="card">
              <div class="table-responsive">
                <table
                  class="
                    table table-vcenter table-hover
                    card-table
                    table-striped table-control
                  "
                >
                  <thead>
                    <tr class="text-muted">
                      <th colspan="2"></th>
                      <th>Kode</th>
                      <th>Qty</th>
                      <th>Harga</th>
                      <th>Sub Total</th>
                      <th>Disc</th>
                      <th>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(row, i) in data_laporan.data">
                      <tr
                        style="text-align: left"
                        class="bg-light"
                        v-if="row.tipe == 'banner'"
                        :key="i"
                      >
                        <th v-html="row.banner" />
                        <th colspan="8">
                          <span style="text-transform: uppercase"
                            >: {{ row.banner_val }}</span
                          >
                        </th>
                      </tr>
                      <tr v-else :key="i">
                        <td></td>
                        <td style="text-align: left">{{ row.item_code }}</td>
                        <td>{{ row.nama_barang }}</td>
                        <td>{{ Math.round(row.qty_dus * 100) / 100 }}</td>
                        <td>{{ row.harga | currency }}</td>
                        <td>{{ row.subtotal | currency }}</td>
                        <td>{{ (row.subtotal - row.dpp) | currency }}</td>
                        <td>{{ row.dpp | currency }}</td>
                      </tr>
                    </template>
                    <template>
                      <tr class="bg-light">
                        <td colspan="8"></td>
                      </tr>
                      <tr>
                        <td
                          colspan="3"
                          style="
                            text-align: right;
                            font-size: 18px;
                            font-weight: 700;
                          "
                        >
                          <b>Grand Total</b>
                        </td>
                        <td>{{ data_grand_total["qty_dus"] | currency }}</td>
                        <td>{{ data_grand_total["harga"] | currency }}</td>
                        <td>{{ data_grand_total["subtotal"] | currency }}</td>
                        <td>
                          {{
                            (data_grand_total["subtotal"] -
                              data_grand_total["dpp"])
                              | currency
                          }}
                        </td>
                        <td>{{ data_grand_total["dpp"] | currency }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormFilter />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import XLSX from "xlsx";

export default {
  name: "LaporanReturSegmen",
  components: { FormFilter },
  mixins: [helper],
  computed: {
    ...mapState(["loading"]),
    ...mapState("retur_segmen", {
      data_filter: (state) => state.data_filter,
      data_laporan: (state) => state.data_laporan,
      data_grand_total: (state) => state.data_grand_total,
    }),
  },
  data() {
    return {
      isDownloadExcel: false
    };
  },

  methods: {
    ...mapActions("retur_segmen", ["getLaporan"]),
    exportPDF() {
      let data = {};
      data.filter = this.data_filter;
      data.laporan = this.data_laporan.data;
      data.grand_total = this.data_grand_total;
      if (localStorage.getItem("retur_segmen") === null) {
        localStorage.retur_segmen = JSON.stringify(data);
      } else {
        localStorage.removeItem("retur_segmen");
        localStorage.retur_segmen = JSON.stringify(data);
      }
      localStorage.retur_segmen = JSON.stringify(data);
      if (this.data_laporan.data.length > 0) {
        window.open(
          window.location.origin + "/dashboard/sales/print-retur-segmen",
          "_blank"
        );
      }
    },
    exportExcel(){
      this.isDownloadExcel = true
      const reports = this.data_laporan.data
      const columnLength = 7;
      const periodReport = `${this.data_filter.start_date} - ${this.data_filter.end_date}`
      let rows = [];
      let templateRow = Array(columnLength).fill("");

      const letterHead = [
        `${this.data_filter.nama_perusahaan.toUpperCase()} | Depo : ${this.data_filter.nama_depo}`,
        'Sales Retur Report by Category and Team',
        `Period :  ${periodReport}`,
      ];

      letterHead.forEach((letter) => {
        let row = [...templateRow];
        row[0] = letter
        rows.push(row)
      })

      rows.push([...templateRow]);
      
      let headerTable = [...templateRow];
      headerTable[2] = 'KODE';
      headerTable[3] = 'QTY';
      headerTable[4] = 'HARGA';
      headerTable[5] = 'SUB TOTAL';
      headerTable[6] = 'DISC';
      headerTable[7] = 'BALANCE';
      rows.push(headerTable);

      reports.forEach((report) => {
        let dataTable = [...templateRow];
        if(report.tipe === 'banner'){
          dataTable[0] = report.banner.toUpperCase();
          dataTable[1] = report.banner_val.toUpperCase();
        } 
        if (report.tipe === 'item'){
          dataTable[2] = `[${report.item_code}]  ${report.nama_barang}`;
          dataTable[3] = report.qty_dus != 0 ? parseFloat(report.qty_dus).toFixed(2) : 0;
          dataTable[4] = report.harga != 0 ? parseFloat(report.harga).toFixed(2) : 0;
          dataTable[5] = report.subtotal != 0 ? parseFloat(report.subtotal).toFixed(2) : 0;
          dataTable[6] = report.disc_nominal != 0 ? parseFloat(report.disc_nominal).toFixed(2) : 0;
          dataTable[7] = report.dpp != 0 ? parseFloat(report.dpp).toFixed(2) : 0;
        }
        rows.push(dataTable);
      })

      let footerTable = [...templateRow];
      footerTable[2] = 'GRAND TOTAL';
      footerTable[3] = this.data_grand_total.qty_dus != 0 ? parseFloat(this.data_grand_total.qty_dus).toFixed(2) : 0;
      footerTable[4] = this.data_grand_total.harga != 0 ? parseFloat(this.data_grand_total.harga).toFixed(2) : 0;
      footerTable[5] = this.data_grand_total.subtotal != 0 ? parseFloat(this.data_grand_total.subtotal).toFixed(2) : 0;
      footerTable[6] = this.data_grand_total.disc_nominal != 0 ? parseFloat(this.data_grand_total.disc_nominal).toFixed(2) : 0;
      footerTable[7] = this.data_grand_total.dpp != 0 ? parseFloat(this.data_grand_total.dpp).toFixed(2) : 0;
      rows.push(footerTable);

      // convert array to worksheet
      let worksheet = XLSX.utils.aoa_to_sheet(rows);

      // set up column width
      worksheet['!cols'] = [
        { wch: 40 },
        { wch: 15 },
        { wch: 65 }, 
        { wch: 5 }, 
        { wch: 10 }, 
        { wch: 10 }, 
        { wch: 10 }, 
        { wch: 10 }, 
      ];

      let workbook = XLSX.utils.book_new(); 
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `laporan-retur-segmen-periode-${periodReport}.xlsx`);
      this.isDownloadExcel = false
    }
  },
  created() {},
};
</script>
